export default __webpack_public_path__ + "static/media/55.07f55ec0.jpg";